import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * Barras pareadas por categoria (p.ej. "antes" vs "despues" de una
 * intervencion, por causa raiz). Una leyenda unica arriba (las series son las
 * mismas para todas las filas) y, por fila, una mini-barra por serie sobre la
 * misma escala 0-100.
 *
 * @param {Array} rows   - { label, values: [pctSerie1, pctSerie2, ...] }
 * @param {Array} series - [{ name, color }] mismo orden que `values`
 */
function GroupedBarChart({ rows, series }) {
    return (
        <Box>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, mb: 2 }}>
                {series.map((s, i) => (
                    <Box key={i} sx={{ display: "flex", alignItems: "center", gap: 0.6 }}>
                        <Box sx={{ width: 9, height: 9, borderRadius: "2px", bgcolor: s.color, flexShrink: 0 }} />
                        <Typography sx={{ fontSize: 11.5, color: "text.secondary" }}>{s.name}</Typography>
                    </Box>
                ))}
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.75 }}>
                {rows.map((row, ri) => (
                    <Box key={ri}>
                        <Typography sx={{ fontSize: 12.5, color: "text.primary", mb: 0.5 }}>{row.label}</Typography>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                            {row.values.map((pct, si) => (
                                <Box key={si} sx={{ display: "grid", gridTemplateColumns: "1fr 40px", alignItems: "center", gap: 1 }}>
                                    <Box sx={{ height: 8, borderRadius: 4, bgcolor: "divider", overflow: "hidden" }}>
                                        <Box sx={{ height: "100%", width: `${pct}%`, bgcolor: series[si]?.color, borderRadius: 4 }} />
                                    </Box>
                                    <Typography sx={{ fontSize: 12, textAlign: "right", color: "text.primary" }}>{pct}%</Typography>
                                </Box>
                            ))}
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}

export default GroupedBarChart;
